import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SessionService } from '@com-delta-idp/mnx-oauth';
import { CommonConstants } from '@com-delta-idp/mnx-skymiles-shared';
import {
  ApiBuilder,
  AppConfigService,
  handleError,
  HttpRequestMethods
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { AddToCart, AddToCartRequest, PurchaseResponse } from '../../models';
import {
  commonHeaderInfo,
  EndpointKeys,
  IDP_APPS
} from '../../models/sky-club.constants';
@Injectable({
  providedIn: 'root'
})
export class PurchaseService {
  errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private session: SessionService
  ) {}

  getPurchaseOptions = (): Observable<PurchaseResponse> => {
    commonHeaderInfo['Authorization'] =
      'Bearer ' + this.session.token.access_token;

    return new ApiBuilder<undefined, PurchaseResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.SKYCLUB)
      .endpointKey(EndpointKeys['PURCHASE_REQUEST_URL'])
      .httpHeaders(commonHeaderInfo)
      .method(HttpRequestMethods['GET_HEADERS'])
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(IDP_APPS.SKYCLUB)
      .create();
  };

  addToCart = (request: AddToCartRequest): Observable<AddToCart> => {
    commonHeaderInfo['Authorization'] =
      'Bearer ' + this.session.token.access_token;
    return new ApiBuilder<AddToCartRequest, AddToCart>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.SKYCLUB)
      .endpointKey(EndpointKeys['ADD_TO_CART'])
      .httpHeaders(commonHeaderInfo)
      .payload(request)
      .method(HttpRequestMethods['POST'])
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(IDP_APPS.SKYCLUB)
      .create();
  };
}
